module.exports = __webpack_public_path__ + "static/media/Team 14 - Soap House.7c99f6b4.png";